import "core-js/modules/es.symbol";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var PanelHeader = function PanelHeader(_ref) {
  var borderless = _ref.borderless,
      centered = _ref.centered,
      className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      titleHeadingLevel = _ref.titleHeadingLevel,
      id = _ref.id,
      otherProps = _objectWithoutProperties(_ref, ["borderless", "centered", "className", "children", "title", "titleHeadingLevel", "id"]);

  var HeadingLevelTag = "h".concat(titleHeadingLevel);
  var headerStylingClass = classnames(className, 'wds-c-panel__header', {
    'wds-c-panel__header--borderless': borderless,
    'wds-u-align--center': centered
  });

  if (!title && !children) {
    console.error('Either a title or children property must be set for a Panel Header component.');
  }

  if (title) {
    return React.createElement("div", _extends({
      className: headerStylingClass
    }, otherProps), React.createElement(HeadingLevelTag, {
      id: id
    }, title));
  }

  return React.createElement("div", _extends({
    className: headerStylingClass
  }, otherProps), children);
};

PanelHeader.propTypes = {
  /** child elements */
  children: PropTypes.node,

  /** additional styling */
  className: PropTypes.string,

  /** The title for the section */
  title: PropTypes.node,

  /** The heading level for the title for the panel */
  titleHeadingLevel: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']),

  /** borderless panel header */
  borderless: PropTypes.bool,

  /** centers content */
  centered: PropTypes.bool,

  /** ID prop that is used for accessibility */
  id: PropTypes.string
};
PanelHeader.defaultProps = {
  title: undefined,
  className: undefined,
  titleHeadingLevel: '4',
  borderless: false,
  centered: false,
  id: undefined,
  children: undefined
};
export default PanelHeader;